import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import Axios from 'axios';

import { SetListData } from 'interface/Data';

const root = ReactDOM.createRoot(document.getElementById('root'));
// ./show_data.json
Axios({
    // url : "./show_data.json",
    url : process.env.REACT_APP_API_URL,
    method : 'GET'
})
.then(response => {

    console.log("response.data initial", response.data);    
    SetListData(response.data);

    root.render(
        <React.Fragment>
            <App />
        </React.Fragment>
    );
});